export const REMOTEHOST =
  process.env.REACT_APP_JBCCL_REMOTEHOST ||
  "https://supervision.alpilink.fr/api";

export const SOCKETHOST =
  process.env.REACT_APP_JBCCL_SOCKETHOST || "wss://supervision.alpilink.fr/";

console.log("Starting client with remote host", REMOTEHOST);



// WEBPACK FOOTER //
// ./src/config.js